import React from 'react';
import LogoutContent from './components/LogoutContent';

import AuthCardLayout from 'layouts/AuthCardLayout';

const LogoutView = () => {
  //logout();
  return (
    <AuthCardLayout>
      <div className="text-center">
        <LogoutContent layout="card" titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
};

export default LogoutView;
